import { MutableRefObject, useEffect, useRef } from 'react';
import Router, { NextRouter } from 'next/router';

function saveScrollPos(url: string) {
    const scrollPos = { x: window.scrollX, y: window.scrollY };
    sessionStorage.setItem(url, JSON.stringify(scrollPos));
}
function getYPosition() {
    return (
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
    );
}

let intervalScroll: any = undefined;

function scrollTo(offsetTop: number) {
    window.scroll({
        left: 0,
        top: offsetTop,
    });
}

function restoreScrollPos(url: string) {
    const scrollPos = JSON.parse(sessionStorage.getItem(url) as any) || {};
    const limitScroll = 10;
    let count = 0;
    let tmpPosY = 0;
    let scrollToPos = scrollPos.y;

    if (scrollPos) {
        const _restore = () => {
            scrollTo(scrollToPos);

            setTimeout(() => {
                const posY = getYPosition();
                if (tmpPosY < posY) {
                    tmpPosY = posY;
                }

                if (
                    tmpPosY > posY ||
                    posY >= scrollPos.y ||
                    count > limitScroll
                ) {
                    clearInterval(intervalScroll);
                }
            }, 150);
            count++;
        };

        scrollTo(scrollToPos);
        intervalScroll = setInterval(_restore, 500);
    }
}

export default function useScrollRestoration(router: NextRouter) {
    const shouldScrollRestore: MutableRefObject<boolean> = useRef(false);

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';

            const onBeforeUnload = (event: BeforeUnloadEvent) => {
                saveScrollPos(router.asPath);
                delete event['returnValue'];
            };

            const onRouteChangeStart = () => {
                clearInterval(intervalScroll);
                saveScrollPos(router.asPath);
            };

            const onRouteChangeComplete = (url: string) => {
                if (shouldScrollRestore.current) {
                    shouldScrollRestore.current = false;
                    (window as any).shouldRenderContentFull = true;
                    restoreScrollPos(url);
                }
            };

            window.addEventListener('beforeunload', onBeforeUnload);
            Router.events.on('routeChangeStart', onRouteChangeStart);
            Router.events.on('routeChangeComplete', onRouteChangeComplete);
            Router.beforePopState(() => {
                (window as any).shouldRenderContentFull = true;

                shouldScrollRestore.current = true;
                return true;
            });

            return () => {
                window.removeEventListener('beforeunload', onBeforeUnload);
                Router.events.off('routeChangeStart', onRouteChangeStart);
                Router.events.off('routeChangeComplete', onRouteChangeComplete);
                Router.beforePopState(() => true);
            };
        }

        return () => { };
    }, [router]);
}
